import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const otherConfigSelector = createSelector(rootSelector, r => r.otherConfig);
export const itemContainersSelector = createSelector(otherConfigSelector, s => s.itemContainers);
export const currentItemContainerSelector = createSelector(otherConfigSelector, s => s.itemContainer);
export const itemContainerViewsSelector = createSelector(otherConfigSelector, s => s.itemContainerViews);
